'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$ErrorData(title, explanation, location, url, user, context) {
  this.CG = null;
  this.CF = null;
  this.JT = null;
  this.JU = null;
  this.Xs = null;
  this.JS = null;
  this.CG = title;
  this.CF = explanation;
  this.JT = location;
  this.JU = url;
  this.Xs = user;
  this.JS = context;
}
export { $c_Lpresto_DangerAlert$ErrorData as $c_Lpresto_DangerAlert$ErrorData };
$p = $c_Lpresto_DangerAlert$ErrorData.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$ErrorData;
/** @constructor */
function $h_Lpresto_DangerAlert$ErrorData() {
}
export { $h_Lpresto_DangerAlert$ErrorData as $h_Lpresto_DangerAlert$ErrorData };
$h_Lpresto_DangerAlert$ErrorData.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_DangerAlert$ErrorData)) {
    if ((((this.CG === x$0.CG) && (this.CF === x$0.CF)) && (this.JT === x$0.JT))) {
      var x = this.JU;
      var x$2 = x$0.JU;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Xs;
      var x$4 = x$0.Xs;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.JS;
      var x$6 = x$0.JS;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "ErrorData";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.CG;
      break;
    }
    case 1: {
      return this.CF;
      break;
    }
    case 2: {
      return this.JT;
      break;
    }
    case 3: {
      return this.JU;
      break;
    }
    case 4: {
      return this.Xs;
      break;
    }
    case 5: {
      return this.JS;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_DangerAlert$ErrorData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.i2)));
}
export { $isArrayOf_Lpresto_DangerAlert$ErrorData as $isArrayOf_Lpresto_DangerAlert$ErrorData };
var $d_Lpresto_DangerAlert$ErrorData = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$ErrorData, "presto.DangerAlert$ErrorData", ({
  i2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_DangerAlert$ErrorData as $d_Lpresto_DangerAlert$ErrorData };
//# sourceMappingURL=presto.-Danger-Alert$-Error-Data.js.map
